import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "abh_cart";

const itemKey = (i) => `${i.type}:${i.ref_id}:${i.variation_id || ""}:${i.size || ""}:${i.registrant?.email || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (item, { openDrawer = true } = {}) => {
    setItems((prev) => {
      const existing = prev.find((i) => itemKey(i) === itemKey(item));
      if (existing) {
        return prev.map((i) =>
          itemKey(i) === itemKey(item) ? { ...i, quantity: Math.min(20, i.quantity + item.quantity) } : i
        );
      }
      return [...prev, item];
    });
    if (openDrawer) setOpen(true);
  };

  const remove = (index) => setItems((prev) => prev.filter((_, i) => i !== index));
  const setQty = (index, qty) =>
    setItems((prev) => prev.map((it, i) => (i === index ? { ...it, quantity: Math.max(1, Math.min(20, qty)) } : it)));
  const clear = () => setItems([]);

  const subtotal = useMemo(() => items.reduce((s, i) => s + i.unit_price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
